/**
 * 权限码
 * 自动生成，请勿手动修改
 */
export const Perms = {
  /**总览 */
  STATISTICS_DASHBOARD: 46,
  /**商品概况 */
  STATISTICS_GOODS: 47,
  /**基础信息 */
  POI_BASIC: 52,
  /**类目管理 */
  GOODS_CATEGORY: 55,
  /**商品与库存 */
  GOODS_GOODS: 56,
  /**退款 */
  ORDER_REFUND: 61,
  /**广告位 */
  OPERATION_BANNER: 63,
  /**公告栏 */
  OPERATION_NOTICE: 64,
  /**套餐卡管理 */
  MARKETING_CARD: 65,
  /**优惠券 */
  MARKETING_COUPON: 66,
  /**促销活动 */
  MARKETING_PROMOTION: 67,
  /**充值规则 */
  MARKETING_RECHARGE: 68,
  /**积分规则 */
  MARKETING_POINT: 69,
  /**新建权限4 */
  TEST_ASDFX: 96,
  /**角色管理 */
  STAFF_ROLE: 114,
  /**员工考勤 */
  STAFF_ATTENDANCE: 115,
  /**编辑员工 */
  STAFF_WRITE: 116,
  /**员工列表 */
  STAFF_LIST: 117,
  /**员工绩效 */
  STAFF_KPI: 118,
  /**预约规则 */
  POI_APPOINTMENT: 119,
  /**订单列表 */
  ORDER_LIST: 120,
  /**客户列表 */
  USER_LIST: 122,
  /**余额退款 */
  USER_BALANCE_REFUND: 123,
  /**经营概况 */
  STATISTICS_OP: 124,
  /**访问概况 */
  STATISTICS_VISIT: 125,
  /**应用管理 */
  SYS_APP: 127,
  /**租户管理 */
  SYS_TENANT: 128,
  /**账号管理 */
  SYS_ACCOUNT: 129,
  /**POS机管理 */
  SYS_POS: 130,
  /**标准化商品库 */
  SYS_SP: 131,
  /**权限管理 */
  SYS_PERMISSION: 132,
  /**余额手动调整 */
  USER_BALANCE_ADJUSTMENT: 133,
} as const;

export type PermsType = typeof Perms;
export type PermKey = keyof PermsType;
export type PermValue = PermsType[PermKey];
export type PermValueRaw = number;
